// Affiliate referral capture.
//
// The marketing site (lightmaster.io) sets a first-party cookie `lm_ref` scoped
// to `.lightmaster.io` when someone arrives via an affiliate link (?ref=CODE).
// Because the app lives on app.lightmaster.io, that parent-domain cookie is
// readable here. We also accept `?ref=CODE` directly on the app (direct links /
// local testing). Whatever we find is persisted to localStorage so it survives
// the multi-step signup, then included in the signUp metadata and consumed by
// the apply_affiliate_referral() DB trigger at org creation.
//
// To mock the marketing-site handoff for testing, set the cookie or use ?ref=:
//   document.cookie = 'lm_ref=patpartner-7h3k; path=/';
//   or visit /auth?ref=patpartner-7h3k

const STORAGE_KEY = 'lm_ref';
const COOKIE_NAME = 'lm_ref';

function readCookie(name: string): string | null {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  } catch {
    return null;
  }
}

/** Read ?ref= or the lm_ref cookie and persist it. Call once on app load. */
export function captureReferralFromEnv(): void {
  try {
    const fromQuery = new URLSearchParams(window.location.search).get('ref');
    const code = (fromQuery || readCookie(COOKIE_NAME) || '').trim();
    if (code) localStorage.setItem(STORAGE_KEY, code);
  } catch {
    /* ignore */
  }
}

/** The captured referral code, if any (localStorage, falling back to cookie). */
export function getCapturedReferral(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY) || readCookie(COOKIE_NAME);
  } catch {
    return null;
  }
}

/** Clear after a successful signup so it isn't reused. */
export function clearCapturedReferral(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
